export const timeNomalize = function (time) {
	time = Date.parse(time) / 1000 / 60 / 60;
	return Math.round(time);
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/GraficMode/components/tools.js